import React from "react";
import { Popover, Checkbox, Typography, Box } from "@mui/material";
const CarrierServiceFilterPopover = ({ anchorEl, handleClose, carrierServices, setCarrierServices, carrierData, }) => {
    const openCarrierService = Boolean(anchorEl);
    // Handle Carrier Selection
    const handleCarrierChange = (carrier) => {
        setCarrierServices((prev) => {
            const isSelected = carrier in prev;
            if (isSelected) {
                // If the carrier is already selected, remove it
                const newState = Object.assign({}, prev);
                delete newState[carrier];
                return newState;
            }
            else {
                // If the carrier is selected, add all its services
                return Object.assign(Object.assign({}, prev), { [carrier]: carrierData[carrier] });
            }
        });
    };
    // Handle Individual Service Selection
    const handleServiceChange = (carrier, service) => {
        setCarrierServices((prev) => {
            const services = prev[carrier] || [];
            const isSelected = services.includes(service);
            if (isSelected) {
                // If service is already selected, remove it
                const updatedServices = services.filter((s) => s !== service);
                if (updatedServices.length === 0) {
                    // If no services remain, remove carrier
                    const newState = Object.assign({}, prev);
                    delete newState[carrier];
                    return newState;
                }
                return Object.assign(Object.assign({}, prev), { [carrier]: updatedServices });
            }
            else {
                // If service is selected, add it
                return Object.assign(Object.assign({}, prev), { [carrier]: [...services, service] });
            }
        });
    };
    return (React.createElement(Popover, { open: openCarrierService, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: { vertical: "bottom", horizontal: "left" } },
        React.createElement(Box, { sx: { p: 2, width: 300 } }, Object.entries(carrierData).map(([carrier, services]) => {
            const selectedServices = carrierServices[carrier] || [];
            const allServicesSelected = services.length > 0 && services.every((s) => selectedServices.includes(s));
            return (React.createElement(Box, { key: carrier, sx: { mb: 1 } },
                React.createElement(Box, { sx: { display: "flex", alignItems: "center" } },
                    React.createElement(Checkbox, { checked: allServicesSelected, indeterminate: !allServicesSelected && selectedServices.length > 0, onChange: () => handleCarrierChange(carrier) }),
                    React.createElement(Typography, { variant: "subtitle2" }, carrier)),
                React.createElement(Box, { sx: { pl: 4 } }, services.map((service) => (React.createElement(Box, { key: service, sx: { display: "flex", alignItems: "center" } },
                    React.createElement(Checkbox, { checked: selectedServices.includes(service), onChange: () => handleServiceChange(carrier, service) }),
                    React.createElement(Typography, { variant: "body2" }, service)))))));
        }))));
};
export default CarrierServiceFilterPopover;
